<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-actions class="justify-center">
                        <v-btn
                            text
                            exact
                            depressed
                            color="teal lighten-2"
                            :to="{ name: 'Orders' }"
                        >
                            <v-icon dense>mdi-arrow-left</v-icon>
                            {{ $t('back') }}
                        </v-btn>
                    </v-card-actions>
                    <v-card-title class="text-uppercase justify-center">{{ title }}</v-card-title>
                </v-card>
                <div class="py-3"></div>
                <order-info
                    :order="order"
                    :deleted="isDeleted"
                    @save="save"
                    @remove="remove"
                ></order-info>
            </v-col>
        </v-row>

        <edit-snackbar
            v-model="isOpenEditSnack"
            :snack-text="editSnackText"
            :snack-color="editSnackColor"
            @close="resetEditSnack"
        ></edit-snackbar>
    </v-container>
</template>

<script>
    import OrderInfo from './OrderInfo';
    import { OrdersService } from '../../../services';
    import { EditSnackbar } from '../../../components/snackbars';
    import { MixinEditSnack } from '../../../mixins';

    export default {
        name: 'Edit',
        mixins: [MixinEditSnack],
        components: {
            OrderInfo,
            EditSnackbar,
        },
        data() {
            return {
                metaUrl: '/orders/edit',
                order: null,
            }
        },
        computed: {
            isDeleted() {
                return this.order?.deleted;
            },
            title() {
                return `${ this.$t('orderEditing') } - ${ this.order ? this.order.id : this.$route.params.id } ${ this.isDeleted ? `(${ this.$t('orderRemoved') })` : '' }`;
            },
        },
        methods: {
            getOrder() {
                OrdersService.setLocale(this.$store.getters.appLanguage);
                OrdersService.getOrder(this.$route.params.id)
                    .then(res => {
                        if (res.data) {
                            this.order = res.data;
                        } else {
                            this.openErrorEditSnack(this.$t('orderNotFound'));
                        }
                    })
                    .catch(() => {
                        this.openErrorEditSnack(this.$t('errorLoading'));
                    });
            },
            save(order) {
                OrdersService.updateOrder(order)
                    .then(res => {
                        if (res.data.error) {
                            this.openErrorEditSnack(res.data.error);
                        } else {
                            this.openSuccessEditSnack();
                        }
                    })
                    .catch(() => {
                        this.openErrorEditSnack();
                    })
            },
            remove(id) {
                OrdersService.deleteOrder(id)
                    .then(res => {
                        if (res.data.success) {
                            this.$router.push({ name: 'Orders' });
                        } else {
                            this.openErrorEditSnack(this.$t('orderRemoveError'));
                        }
                    })
                    .catch(() => {
                        this.openErrorEditSnack(this.$t('orderRemoveError'));
                    })
            },
        },
        created() {
            this.getOrder();
        },
    }
</script>

<style scoped>

</style>
